import type { AssessmentQuestion } from '@entities/assessment'

import imgQuestion1 from '../../../../ui/images/questions/math/grade-k1/question-1.png'
import imgQuestion2 from '../../../../ui/images/questions/math/grade-k1/question-2.png'
import imgQuestion3 from '../../../../ui/images/questions/math/grade-k1/question-3.png'
import imgQuestion4 from '../../../../ui/images/questions/math/grade-k1/question-4.png'
import imgQuestion5 from '../../../../ui/images/questions/math/grade-k1/question-5.png'
import imgQuestion6 from '../../../../ui/images/questions/math/grade-k1/question-6.png'
import imgQuestion7 from '../../../../ui/images/questions/math/grade-k1/question-7.png'

export const questions: AssessmentQuestion[] = [
  {
    name: 'grade_k1_1',
    title: 'Count on by adding 2 numbers to complete the missing sequence.',
    topic: 'Number sequence.',
    image: imgQuestion1,
    answers: [
      {
        name: 'grade_k1_1_a',
        text: '32, 33, 40, 42, 43',
      },
      {
        name: 'grade_k1_1_b',
        text: '32, 36, 40, 41, 42',
      },
      {
        name: 'grade_k1_1_c',
        text: '35, 36, 40, 42, 48',
      },
      {
        name: 'grade_k1_1_d',
        text: '34, 38, 42, 48',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k1_2',
    title: 'How many ladybirds can you see here altogether?',
    topic: 'Basic addition.',
    image: imgQuestion2,
    condition: '6 + 2 = _',
    answers: [
      {
        name: 'grade_k1_2_a',
        text: '1',
      },
      {
        name: 'grade_k1_2_b',
        text: '8',
        correct: true,
      },
      {
        name: 'grade_k1_2_c',
        text: '4',
      },
      {
        name: 'grade_k1_2_d',
        text: '7',
      },
    ],
  },
  {
    name: 'grade_k1_3',
    title: 'Sam bought 6 cars, then he bought 4 more. What is the total number of cars he has?',
    topic: 'Word problem using addition to 10.',
    image: imgQuestion3,
    condition: '4 + 6 = _',
    answers: [
      {
        name: 'grade_k1_3_a',
        text: '10',
        correct: true,
      },
      {
        name: 'grade_k1_3_b',
        text: '15',
      },
      {
        name: 'grade_k1_3_c',
        text: '9',
      },
      {
        name: 'grade_k1_3_d',
        text: '12',
      },
    ],
  },
  {
    name: 'grade_k1_4',
    title: 'There are 9 houses in the picture. 4 out of them are crossed out. How many houses are left?',
    topic: 'Subtraction without regrouping.',
    image: imgQuestion4,
    condition: '9 - 4 = _',
    answers: [
      {
        name: 'grade_k1_4_a',
        text: '14',
      },
      {
        name: 'grade_k1_4_b',
        text: '13',
      },
      {
        name: 'grade_k1_4_c',
        text: '5',
        correct: true,
      },
      {
        name: 'grade_k1_4_d',
        text: '10',
      },
    ],
  },
  {
    name: 'grade_k1_5',
    title: 'Liz saw 2 ice creams on the table. Before she took one, someone else took the two ice creams away. How many ice creams did Liz take?',
    topic: 'Word problem using basic subtraction.',
    image: imgQuestion5,
    condition: '2 - 2 = _',
    answers: [
      {
        name: 'grade_k1_5_a',
        text: '4',
      },
      {
        name: 'grade_k1_5_b',
        text: '0',
        correct: true,
      },
      {
        name: 'grade_k1_5_c',
        text: '1',
      },
      {
        name: 'grade_k1_5_d',
        text: '2',
      },
    ],
  },
  {
    name: 'grade_k1_6',
    title: 'Can you guess what time these watches are showing?',
    topic: 'Time measurement',
    image: imgQuestion6,
    answers: [
      {
        name: 'grade_k1_6_a',
        text: '11:30, 1:30, 8:30',
      },
      {
        name: 'grade_k1_6_b',
        text: '11:00, 1:00, 8:30',
      },
      {
        name: 'grade_k1_6_c',
        text: '11:00, 1:30, 8:00',
      },
      {
        name: 'grade_k1_6_d',
        text: '11:00, 1:30, 8:30',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k1_7',
    title: 'How many triangles can you spot in the given picture?',
    topic: 'Identifying Shapes',
    image: imgQuestion7,
    answers: [
      {
        name: 'grade_k1_7_a',
        text: '2',
      },
      {
        name: 'grade_k1_7_b',
        text: '3',
        correct: true,
      },
      {
        name: 'grade_k1_7_c',
        text: '5',
      },
      {
        name: 'grade_k1_7_d',
        text: '4',
      },
    ],
  },
  {
    name: 'grade_k1_8',
    title: 'Can you guess the INCORRECT group?',
    topic: 'Compare 2-digit numbers.',
    answers: [
      {
        name: 'grade_k1_8_a',
        text: '36 > 35',
      },
      {
        name: 'grade_k1_8_b',
        text: '10 < 12',
      },
      {
        name: 'grade_k1_8_c',
        text: '10 > 5 + 5',
        correct: true,
      },
      {
        name: 'grade_k1_8_d',
        text: '17 = 15 + 2',
      },
    ],
  },
  {
    name: 'grade_k1_9',
    title: 'Nina had $7. Her dad gave her $5 more. Count the total money that Nina had.',
    topic: 'Counting Money.',
    answers: [
      {
        name: 'grade_k1_9_a',
        text: '$12',
        correct: true,
      },
      {
        name: 'grade_k1_9_b',
        text: '$15',
      },
      {
        name: 'grade_k1_9_c',
        text: '$10',
      },
      {
        name: 'grade_k1_9_d',
        text: '$20',
      },
    ],
  },
  {
    name: 'grade_k1_10',
    title: 'John has ¢72 in his wallet. He spent ¢35 to buy a pen. How many cents are left in his wallet?\n',
    topic: 'Counting Money',
    answers: [
      {
        name: 'grade_k1_10_a',
        text: '¢45',
      },
      {
        name: 'grade_k1_10_b',
        text: '¢50',
      },
      {
        name: 'grade_k1_10_c',
        text: '¢30',
      },
      {
        name: 'grade_k1_10_d',
        text: '¢37',
        correct: true,
      },
    ],
  },
]
